import CompletedAvailableCard from "./CompletedAvailableCard";

export default CompletedAvailableCard;
